// home.js
import React from 'react';
import ReservationStore from '../../stores/ReservationStore';
import Reservation from './reservation';
import Cancelled from './cancelled';
import SeatActionSuccess from './seatActionSuccess';
import Search from './search';
import UserStore from '../../stores/UserStore';
import Head from '../head';

class EditTrip extends React.Component {
  constructor(props) {
    super(props);
    this.onReservationChange = this.onReservationChange.bind(this);
    var query = (props.location && props.location.query) || {};
    var seatAction = query.seatAction || null;
    var showSuccess = !!seatAction;
    this.state = {
      reservation: null,
      currentStep: showSuccess ? 4 : 1,
      refund: 0,
      cancelledSeats: [],
      email: '',
      seatAction: showSuccess ? seatAction : null,
      seatActionDetails: showSuccess ? (query.details || null) : null,
      seatActionReservation: showSuccess ? (query.reservationNumber || null) : null,
    };
  }

  clearReservation(email){
    this.setState({reservation: null, email: email});
  }

  setRefund(val, cancelledSeats, cancelledCount, totalTickets) {
    this.setState({ refund: val, cancelledSeats: cancelledSeats || [], cancelledCount: cancelledCount || 0, totalTickets: totalTickets || 0, currentStep: 3 });
  }

  onReservationChange(){
    let result = ReservationStore.getReservation();
    if(result) {
      this.setState({reservation: result, currentStep: 2});
    }
  }

  componentWillReceiveProps(nextProps) {
    var nextQuery = (nextProps.location && nextProps.location.query) || {};
    var nextSeatAction = nextQuery.seatAction || null;
    if (this.state.currentStep === 4 && !nextSeatAction) {
      this.setState({ currentStep: 1, seatAction: null, seatActionDetails: null, seatActionReservation: null });
    }
  }

  componentDidMount() {
    ReservationStore.addReservationChangeListener(this.onReservationChange);
  }

  componentWillUnmount() {
    ReservationStore.removeReservationChangeListener(this.onReservationChange);
  }

  render() {
  	return (
      <div>
        <Head title="Edit Trip - Tripper Bus" />

        <header className="text-center">
        </header>

        {this.state.currentStep === 1 && <Search
          clearReservation = {this.clearReservation.bind(this)}
          location = {this.props.location}
        />}

        {this.state.currentStep === 2 && <Reservation
          reservation = {this.state.reservation}
          clearReservation = {this.clearReservation.bind(this)}
          setRefund = {this.setRefund.bind(this)}
        />}

        {this.state.currentStep === 3 && <Cancelled email={this.state.email} refund={this.state.refund} cancelledSeats={this.state.cancelledSeats} cancelledCount={this.state.cancelledCount} totalTickets={this.state.totalTickets}/>}

        {this.state.currentStep === 4 && <SeatActionSuccess
          action={this.state.seatAction}
          details={this.state.seatActionDetails}
          reservationNumber={this.state.seatActionReservation}
        />}

      </div>
  	)
  }
}

export default EditTrip;
